import { OptionType } from '@evinced-private/ui-common';

import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';

import { RequestPayload } from '../types/PayloadTypes';

/**
 * Creates a request payload for a specific row
 */
const createRowPayload = (runId: string, changes: unknown[]): RequestPayload => {
	return {
		scope: {
			conditions: [{ field: 'run_id', value: runId }],
			entityName: 'all'
		},
		changes
	};
};

/**
 * Builds payloads for all rows that have additions
 */
export const buildPayloadsForRows = (
	testRows: IWebSdkTest[],
	rowIdToAdditionsMap: Map<string, Array<{ labelType: OptionType; value: OptionType }>>,
	buildChanges: (
		row: IWebSdkTest,
		additions: Array<{ labelType: OptionType; value: OptionType }>
	) => unknown[]
): RequestPayload[] => {
	const updates: RequestPayload[] = [];

	for (const row of testRows) {
		if (!row.runId) {
			continue;
		}

		const rowAdditions = rowIdToAdditionsMap.get(row.runId);
		if (!rowAdditions || rowAdditions.length === 0) {
			continue;
		}

		const changes = buildChanges(row, rowAdditions);

		if (changes.length > 0) {
			updates.push(createRowPayload(row.runId, changes));
		}
	}

	return updates;
};
